import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Validators, UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { UserCommonService } from '../../services/user-common.service';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { ErrorBindingService } from '../../services/error-binding.service';

@Component({
    selector: 'app-set-password',
    templateUrl: './set-password.component.html',
    standalone: false
})
export class SetPasswordComponent implements OnInit {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() setPasswordPopClose: EventEmitter<any> = new EventEmitter();
  @Input() otpId;

  passwordError = [{
    message: false
  }];

  errorMessage: any[] = [];

  setPasswordForm = new UntypedFormGroup({
    newPassword: new UntypedFormControl(),
    newConfirmPassword: new UntypedFormControl()
  });

  constructor(private formBuilder: UntypedFormBuilder,
    private signOutService: UserCommonService,
    private commonService: CommonBindingDataService,
    private errorBindingService: ErrorBindingService) { }

  ngOnInit() {
    this.setPasswordForm = this.formBuilder.group({
      newPassword: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(25)]],
      newConfirmPassword: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(25)]]
    });
  }


  passwordNotMatched() {
    if (this.setPasswordForm.controls.newPassword.value !== this.setPasswordForm.controls.newConfirmPassword.value) {
      // const error = {
        // general: [
        //   {
        //     message: this.commonService.getLabel('error_new_confirm_password_not_match')
        //   }
        // ]
      // this.errorBindingService.onAPIValidationError(JSON.stringify(error), this.passwordError);
    } else {
      return true;
    }
  }

  requestData() {
    return {
      otpId: this.otpId,
      password: this.setPasswordForm.controls.newPassword.value,
    };
  }

  doChangePassword() {
    const passwordVerified = this.passwordNotMatched();
    if (passwordVerified) {
      const data = this.requestData();
      this.signOutService.setPassword(JSON.stringify(data)).subscribe({
        next:(results) => {
        if (results.general !== null && results.general !== undefined) {
          results.general.forEach(element => {
            this.errorMessage = [];
            this.errorMessage.push({ severity: 'success', summary: 'Success', detail: element.message });
          });
          setTimeout(() => {
            this.setPasswordForm.reset();
            this.setPasswordPopClose.emit(false);
          }, 2000);
        }
      }, error:(error) => {
        if (error.general !== null && error.general !== undefined) {
          error.general.forEach(element => {
            this.errorMessage = [];
            this.errorMessage.push({ severity: 'warn', summary: 'Error', detail: element.message });
          });
        }
      }
      });
    }

  }

  onCancel() {
    this.setPasswordForm.reset();
    this.setPasswordPopClose.emit(false);
  }

}
